"use client";

import { ReactNode, createContext, useContext, useState } from "react";

import { ShowInfo } from "@punchup/data/legacy/shows";

interface TixologiWidgetContextType {
  isOpen: boolean;
  show: ShowInfo | null;
  open: (show: ShowInfo) => void;
  close: () => void;
}

const TixologiWidgetContext = createContext<
  TixologiWidgetContextType | undefined
>(undefined);

interface Props {
  children: ReactNode;
}

export const TixologiWidgetProvider = ({ children }: Props) => {
  const [isOpen, setIsOpen] = useState(false);
  const [show, setShow] = useState<ShowInfo | null>(null);

  // open the widget and set the show
  const open = (show: ShowInfo) => {
    setShow(show);
    setIsOpen(true);
  };

  // close the widget and clear the show
  const close = () => {
    setIsOpen(false);
    setShow(null);
  };

  return (
    <TixologiWidgetContext.Provider value={{ isOpen, show, open, close }}>
      {children}
    </TixologiWidgetContext.Provider>
  );
};

export const useTixologiWidget = (): TixologiWidgetContextType => {
  const ctx = useContext(TixologiWidgetContext);
  if (!ctx)
    throw new Error(
      "useTixologiWidget must be used within TixologiWidgetProvider"
    );
  return ctx;
};
